/**
 * Query keys for the workout domain (`../core/keys.ts` is the convention).
 *
 * ── `sessions` (THE LIST) AND `session` (ONE) ARE TWO SUB-KEYS ─────────────
 * `["workout","sessions",range]` is the history list; `["workout","session",
 * id]` is one session, and its summary sits UNDER it
 * (`["workout","session",id,"summary"]`), so invalidating a session's detail
 * also reaches its summary — which is recomputed from the same sets.
 *
 * An omitted bound is written as `null`, so `{}` and `{ from: undefined }` are
 * one key, not two. The exercise ids keep the caller's order: the answer is
 * the same either way, and sorting here would be a second opinion about a
 * list the chart already owns.
 */
export const workoutKeys = {
    /** Every workout read. */
    all: ["workout"],
    /** The history list over one range; `sessionsAll` is every range. */
    sessions: (range = {}) => [
        "workout",
        "sessions",
        { from: range.from ?? null, to: range.to ?? null },
    ],
    sessionsAll: ["workout", "sessions"],
    /** One session with its sets; `sessionAll` is every session and summary. */
    session: (sessionId) => ["workout", "session", sessionId],
    sessionAll: ["workout", "session"],
    /** Under the session's key on purpose (see above). */
    summary: (sessionId) => ["workout", "session", sessionId, "summary"],
    history: (range = {}) => [
        "workout",
        "history",
        {
            exerciseIds: range.exerciseIds ?? [],
            from: range.from ?? null,
            to: range.to ?? null,
        },
    ],
    historyAll: ["workout", "history"],
    /**
     * One exercise's records (`D199`). NOT under `historyAll`, although they are
     * folded from the same sets: `coveringHistory` (the app's
     * `sessions-placeholder.ts`) reads every entry under that prefix as a
     * history and its third segment as a range, and a records entry there
     * would be served as a placeholder history with no `sets`. Every set write
     * names `recordsAll` beside `historyAll` instead (`SET_WRITES`).
     */
    records: (exerciseId) => ["workout", "records", exerciseId],
    recordsAll: ["workout", "records"],
    stats: ["workout", "stats"],
};
//# sourceMappingURL=keys.js.map